// frontend/src/components/SearchBar.jsx
import { useState, useEffect, useRef } from "react";

const categoriasOrdenadas = [
  "Artigos Infantis",
  "Aventura e Lazer",
  "Brinquedos e Bicicletas",
  "Celulares",
  "Decoração e Lar",
  "Eletro",
  "Esporte e Fitness",
  "Ferramentas, Construção e Reforma",
  "Hobbies, Musica, Arte e Livros",
  "Home Office",
  "Imóveis",
  "Informática e Games",
  "Moda e Achados de Estilo",
  "Moveis",
  "Mundo Pets",
  "TV, Audio, Video e Drones",
  "Veículos e Autopeças",
];

// 👇 USAR IDs en lugar de nombres
const condominiosDisponiveis = [
  { id: 1, nome: "Gran Ville São Venâncio" },
  { id: 2, nome: "Bela Vista" },
  { id: 3, nome: "Residencial Pecan" },
  { id: 4, nome: "Condomínio Terras da Alvorada" },
];

export default function SearchBar({ 
  searchTerm, 
  setSearchTerm, 
  selectedCategory, 
  setSelectedCategory,
  selectedCondominio,
  setSelectedCondominio 
}) {
  const [isVisible, setIsVisible] = useState(true);
  const lastScrollY = useRef(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (!isMobile) {
        setIsVisible(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!isMobile) return;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY > lastScrollY.current && currentScrollY > 60) {
        setIsVisible(false);
      } else if (currentScrollY < lastScrollY.current) {
        setIsVisible(true);
      }
      
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isMobile]);

  return (
    <div 
      className={`bg-white border-b border-gray-200 sticky top-[71px] md:top-[64px] z-40 shadow-sm transition-transform duration-300 ${
        isMobile && !isVisible ? "-translate-y-full" : "translate-y-0"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 py-2 md:py-3">
        <div className="flex flex-col md:flex-row gap-2 md:gap-3">
          {/* 🔥 INPUT - TEXTO MÁS PEQUEÑO EN MOBILE */}
          <div className="flex-grow">
            <div className="relative">
              <input
                type="text"
                placeholder="O que você está procurando?"
                className="w-full px-3 py-2 md:px-4 md:py-3 text-sm md:text-base border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#5daf8e] focus:border-[#449879] placeholder:text-sm md:placeholder:text-base"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button className="absolute right-0 top-0 h-full bg-[#449879] text-white px-3 md:px-5 text-sm md:text-base rounded-r-lg hover:bg-[#367d64] transition-colors font-medium">
                🔍 Buscar
              </button>
            </div>
          </div>

          {/* 🔥 SELECTS - TEXTO MÁS PEQUEÑO EN MOBILE */}
          <div className="w-full md:w-56">
            <select
              className="w-full px-3 py-2 md:px-4 md:py-3 text-sm md:text-base border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#5daf8e] focus:border-[#449879] text-gray-700"
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              <option value="">Todas as categorias</option>
              {categoriasOrdenadas.map((categoria) => (
                <option key={categoria} value={categoria}>
                  {categoria}
                </option>
              ))}
            </select>
          </div>

          <div className="w-full md:w-56">
            <select
              className="w-full px-3 py-2 md:px-4 md:py-3 text-sm md:text-base border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#5daf8e] focus:border-[#449879] text-gray-700"
              value={selectedCondominio}
              onChange={(e) => setSelectedCondominio(e.target.value)}
            >
              <option value="">Todos os condomínios</option>
              {condominiosDisponiveis.map((condominio) => (
                <option key={condominio.id} value={condominio.id}>
                  {condominio.nome}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}